export const fields = {
  name: 'name',
  countryCode: 'countryCode',
  line1: 'line1',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode',
  phone: 'phone',
  email: 'email',
  cardName: 'cardName',
  cardProvider: 'cardProvider',
  cardNumber: 'cardNumber',
  expiry: 'expiry',
  cvv: 'cvv',
  accountNickName: 'accountNickName',
  ianaTimeZone: 'ianaTimeZone',
};
